import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl text-background-50">西瓜影视</span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed">
                高清不缓冲在线观看平台，提供海量电影、电视剧、动漫、综艺等内容，蓝光超清画质，流畅播放体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">影视分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <a href="#" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap">帮助中心</a>
                </li>
                <li>
                  <a href="#" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap">意见反馈</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2 text-sm text-foreground-300">
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line"></i>
                  </div>
                  service@xiguays.com
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-customer-service-2-line"></i>
                  </div>
                  在线客服：7×24小时
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} 西瓜影视 xiguays.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-400 hover:text-background-50 text-xs transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-400 hover:text-background-50 text-xs transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-foreground-400 hover:text-background-50 text-xs transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}